import { makeLoadable } from '../common/LoadableWrapper';
const AsyncDevGateToggle = makeLoadable({
  loader: () => import( /* webpackChunkName: "dev-gate-toggle" */'./DevToggle')
});
export default AsyncDevGateToggle;